export default {
  translations: {
    home: {
      welcome: "Welcome!",
    },
    header: {
      menu: {
        portal: "Portal",
        planning: "Planning",
        production: "Production",
        requests: "Requests",
        deliveries: "Deliveries",
        stock: "Stock",
        dashboard: "Dashboard",
      },
      submenu: {
        portal: {
          portalParameters: "Portal Parameters",
          parameters: "Parameters",
          partner: "Partner",
          agregatedPartner: "Aggregated Partner",
          parameterPartner: "Partner Parameters",
          profile: "Profile",
          user: "User",
          passwordChange: "Password Change",
          ssoConfig: "SSO Configuration",
          basicData: "Basic Data",
          emailGroups: "Email Groups",
        },
        planning: {
          justification: "Justification",
          projects: "Projects",
          contract: "Contract",
          monthlyForecats: "Monthly Forecast",
          dailyForecats: "Daily Forecast",
          stuffRequest: "Raw Material Request",
        },
        production: {
          dailyProductionRelease: "Daily Production Release",
          deviationsApproval: "Deviations Approval",
        },
        requests: {
          finishedProduct: "Finished Product",
          importRequest: "Import Request",
        },
        deliveries: {
          fob: "FOB",
          cif: "CIF",
          stuff: "Raw Material",
        },
        stock: {
          brfPartner: "BRF Partner",
          partner: "Partner",
        },
        dashboad: {
          productionMonitoring: "Production Monitoring",
          contractualConsumption: "Contractual Consumption",
          import: "Import",
          partnerMonitoring: "Partner Monitoring",
        },
      },
      selectPartner: "Select a Partner",
      partner: "Partner",
      partnerTooltip:
        "Displays a list of Partners to select the partner whose data will be presented!",
      account: {
        myAccount: "My Account",
        changePass: "Password Change",
        logout: "Logout",
      },
    },
    pages: {
      portalParameters: {
        title: "Portal Parameters",
        text: {
          parameter: "Parameter",
          routine: "Routine",
          value: "Value",
          newParameter: "New Parameter",
          successNew: "Parameter added successfully!",
          successUpdate: "Parameter updated successfully!",
          successExclusion: "Parameter deleted successfully!",
          updateParameterData: "Update Parameter Data",
          excludeItemQuestionTitle: "Contract Item Deletion?",
          excludeItemQuestionSubTitle: "You requested the deletion of the parameter.",
          excludeItemQuestionConfirmation: "Do you confirm the operation?",
          searchRoutine: "Search Routine",
        },
      },
      parameters: {
        title: "Parameters",
        text: {
          parameter: "Parameter",
          properties: "Properties",
          value: "Value",
          newParameter: "New Parameter",
          successNew: "Property added successfully!",
          successUpdate: "Property updated successfully!",
          successExclusion: "Property deleted successfully!",
          updateParameterData: "Update Parameter Data",
          excludeItemQuestionTitle: "Contract Item Deletion?",
          excludeItemQuestionSubTitle: "You requested the deletion of the parameter.",
          excludeItemQuestionConfirmation: "Do you confirm the operation?",
          searchRoutine: "Search Routine",
          modalTitle: "Contract Item Deletion?",
          modalText: "You requested the deletion of the parameter.",
          modalText2: "Parameter: ",
          modalText3: "Value: ",
          modalText4: "Do you confirm the operation?",
        },
      },
      partners: {
        titlePage: "Partners",
        titleList: "Partner Listing",
        titleDetails: "Partner Details",
        text: {
          sapCode: "SAP Code",
          sapSupplier: "SAP Supplier",
          status: "Status",
          partnersFilter: "Filter Partners",
          removeFilters: "Remove Filters",
          blockPartner: "Block Partner",
          unlockPartner: "Unlock Partner",
          blockSuccess: "Partner blocked successfully!",
          restoreSuccess: "Partner restored successfully!",
          savePartnerData: "Save Partner Data",
          updateSuccess: "Data updated successfully!",
          updateFail: "Unable to update partner data.",
          backToList: "Back to Listing",
          partnerEmail: "Partner Email",
          partnerEmails: "Partner Emails",
          partnerDataUpdate: "Update Partner Data",
          filterOfPartners: "Partner Filter",
          filterOptions: "You can search by name, SAP code, or nickname.",
          autoCompleteNoOptions: "No options, please request access from the administrator.",
        },
      },
      partnerParameters: {
        titlePage: "Partner Parameters",
        text: {
          paramSearch: "Search Parameter",
          property: "Property",
          parameter: "Parameter",
          value: "Value",
          newParameter: "New Parameter",
          updateParameter: "Update Parameter Data",
          successNewProperty: "Property added successfully!",
          successUpdateProperty: "Property updated successfully!",
          successExclusionProperty: "Property deleted successfully!",
          recoverDataFailure: "Failed to retrieve Partner Parameters data!",
          excludeSuccess: "Parameter deleted successfully!",
          excludeItemQuestionTitle: "Contract Item Deletion?",
          excludeItemQuestionSubTitle: "You requested the deletion of the parameter.",
          excludeItemQuestionConfirmation: "Do you confirm the operation?",
        },
      },
      user: {
        titlePage: "User",
        text: {
          password: "Password",
          generateRandomPassword: "Generate Random Password",
          accessFails: "Access Failures",
          profile: "Profile",
          newUser: "New User",
          userPartners: "User Partners",
          userRelatedPartners: "Partners linked to User",
          userDataUpdate: "Update User Data",
          userDataDelete: "Delete User Data",
          preSelectedFieldsSearch: "Search using pre-selected fields!",
          lockedForLogin: "Locked for Login",
          unlockedForLogin: "Unlocked for Login",
          requiredEmailField: "Email field is required.",
          requiredNameField: "Name field is required.",
          requiredPasswordField: "Password field is required.",
          requiredPartnetField: "Select at least one partner.",
          invalidEmailField: "Invalid email format.",
          saveUser: "Save User",
          successSaveUser: "User saved successfully.",
          deleteUser: "Delete User",
          successDeleteUser: "User deleted successfully.",
          searchFieldNotRecognized: "Search field not recognized.",
          userWith: "User with",
          notFounded: "not found.",
          searchUser: "Search User",
          userRootWarning: "Root user has access to all partners, no need to link them.",
          understand: "I understand",
          selectFieldandValueToSearch: "Select the Field and Value to search",
          field: "Field",
          partners: "Partners",
        },
      },
      password: {
        titlePage: "Password Change",
        text: {
          passwordChange: "Password Change",
          passwordUpdate: "Update Password",
          actualPassword: "Current Password",
          newPassword: "New Password",
          newPasswordConfirmation: "New Password Confirmation",
          passwordChangeSuccess: "Password changed successfully, you will be redirected to the login screen!",
          passwordChangeFailure: "Unable to change your password. Please review the steps and try again!",
          confirm: "Confirm Operation",
          confirmQuestion: "Are you sure you want to {{text}} the password?",
          oldPasswordRequired: "Old password must be provided!",
          newPasswordRequired: "A new password must be provided!",
          newPasswordConfirmationRequired: "New password confirmation must be provided!",
          passwordsNotMatched: "Passwords do not match!",
          newPasswordAndOldPasswordEqual: "New password cannot be the same as the old password!",
          pleaseVerify: "Please verify the",
          verifyItemPlural: "following items:",
          verifyItemSingular: "following item:",
          fillingError: "Filling Errors",
        },
      },
      basicData: {
        titlePage: "Basic Data",
        text: {
          sapSupplierCode: "SAP Supplier Code",
          sapClientCode: "SAP Client Code",
          partners: "Partners",
          sku: "SKU",
          distributionCenter: "Distribution Center",
        },
      },
      emailsGroups: {
        titlePage: "Email Groups",
        text: {
          emails: "Emails",
          routine: "Routine",
          routines: "Routines",
          registeredEmails: "Registered Emails",
          registeredGroups: "Registered Groups",
          emailCreatedWithSuccess: "Email created successfully",
          emailRemovedWithSuccess: "Email removed successfully!",
          registerUpdatedWithSuccess: "Record updated successfully",
          savingDataFrom: "Saving data from",
          groupRemovedWithSuccess: "Group removed successfully",
          emailRegister: "Register Email",
          emailRemove: "Delete Email",
          groupRegister: "Register Group",
          groupRemove: "Delete Group",
          emailAddToGroupWithSuccess: "Email added to group successfully",
          linkedEmails: "Linked Emails",
          addEmail: "Add Email",
          routineCreatedWithSuccess: "Routine created successfully",
          routineAddedToGroupWithSuccess: "Routine added to group successfully",
          routineRemovedWithSuccess: "Routine removed successfully",
          linkedRoutines: "Linked Routines",
          addRoutine: "Add Routine",
        },
      },
      justifications: {
        titlePage: "Justifications",
        text: {
          successNewProperty: "Property added successfully!",
          successUpdateProperty: "Property updated successfully!",
          justificationExclusionWithSuccess: "Justification deleted successfully!",
          newJustification: "New Justification",
          updateParametersData: "Update Parameter Data",
          excludeItemQuestionTitle: "Justification Deletion?",
          excludeItemQuestionSubTitle: "You requested the deletion of the justification.",
          excludeItemQuestionConfirmation: "Do you confirm the operation?",
          justification: "Justification",
        },
      },
      projects: {
        titlePage: "Projects",
        text: {
          successNewProject: "Project added successfully!",
          successUpdateProject: "Project updated successfully!",
          projectExclusionWithSuccess: "Project deleted successfully!",
          newProject: "New Project",
          updateProjectData: "Update Project Data",
          excludeItemQuestionTitle: "Project Deletion?",
          excludeItemQuestionSubTitle: "You requested the deletion of the project.",
          excludeItemQuestionConfirmation: "Do you confirm the operation?",
          project: "Project",
          projectName: "Project Name",
        },
      },
      contracts: {
        titlePage: "Contracts",
        titleList: "Contract List",
        text: {
          newContract: "New Contract",
          contractItems: "Contract Items",
          contractItem: "Contract Item",
          contract: "Contract",
          warningStartDate: "Start Date must be earlier than End Date!",
          warningContractNumber: "This contract number already exists for this Partner, duplicates are not allowed, please adjust!",
          saveContract: "Save Contract",
          informContractNumber: "Provide contract number",
          saveWithSuccess: "Contract saved successfully!",
          excludeContract: "Delete Contract",
          excludeWithSuccess: "Contract deleted successfully!",
          excludeError: "Error trying to delete the contract",
          addItemToContract: "Add Item to Contract",
          updateContractItem: "Update Contract Item",
          addItemsToContract: "Add Items to Contract",
          contractItemDeleteWithSuccess: "Contract Item deleted successfully!",
          contractItemDeleteError: "Error trying to delete contract item!",
          contractItemUpdateWithSuccess: "Contract Item updated successfully!",
          itemUpdateWithSuccess: "Item updated successfully!",
          generateMonthlyForecast: "Generate Monthly Forecast",
          monthlyForecats: "Monthly Forecast",
          monthlyForecatsContinue: "Do you want to continue with the monthly forecast?",
          reverseForecast: "Reverse Forecast",
          reverseForecastProceed: "Do you want to proceed with the Forecast Reversal?",
          reverseForecastSuccess: "Forecast reversal completed successfully!",
          reverseForecastUnsuccessful: "Forecast reversal was not completed!",
          contractForecast: "Contract Forecast",
          forPartner: "for partner",
          andSku: "and for SKU",
          generatedWithSuccess: "was generated successfully!",
          contractNumber: "Contract Number",
          priceFrequency: "Price Update Frequency (Month)",
          agreedPenalty: "Agreed Penalty",
          penalty: "Penalty",
          beginningOfTerm: "Start of Term *",
          endOfTerm: "End of Term *",
          shippingMode: "Shipping Mode *",
          modalExit: "Exit Modal",
          yearReference: "Reference Year",
          anualQuantity: "Annual Quantity",
          excludeItemQuestionTitle: "Contract Deletion?",
          excludeItemQuestionSubTitle: "You requested the deletion of the contract.",
          excludeItemQuestionConfirmation: "Do you confirm the operation?",
          excludeItemQuestionTitle2: "Contract Item Deletion?",
          excludeItemQuestionSubTitle2: "You requested the deletion of the contract item.",
          excludeItemQuestionConfirmation2: "Do you confirm the operation?",
          removeItem: "Delete Item",
          blockStuff: "Block Material",
          unblockStuff: "Unblock Material",
          project: "Project",
          titlePenalty: "Agreed Penalty",
          contractDetails: "Contract Details",
          contractModalTitle: "Origins and SAP Contracts",
        },
      },
      monthlyForecast: {
        titlePage: "Monthly Forecast",
        text: {
          defineBasePlan: "Define Base Plan",
          suggestChanges: "Suggest Changes",
          approveDisapproveProposal: "Approve/Disapprove Proposal",
          frozenAndDiarized: "Frozen and Diarized",
          allStepsHaveBeenCompleted: "All steps have been completed.",
          includingForecastGeneration: "Including forecast generation.",
          itIsStillPossibleToChangeContractData: "It is still possible to change contract data,",
          howeverRecreateTheForecast: "However, it will not be possible to recreate the forecast for already created SKUs and exercises!",
          theFinalStep: "The final step will be carried out for SKUs included after the last forecast generation on:",
          contractConsumption: "Contract Consumption",
          exitModal: "Exit Modal",
          sAPSupplierCode: "SAP Supplier Code",
          contractNumber: "Contract Number",
          percentageConsumed: "Percentage Consumed",
          approvalDataTitle: "Approve the data of the selected Item(s) in the list below, and proceed to the next step!",
          approvalDataTitle2: "If not generated, this operation will generate the 'Diarized' Forecast!",
          contractNotSelected: "Contract not selected",
          withoutContract: "Without contract!",
          integratedSelectedItems: "The {{quantityItems}} items selected in the grid were successfully integrated!",
          integratedSelectedItems2: "The selected item in the grid was successfully integrated!",
          updatedSelectedItems: "The {{quantityItems}} items selected in the grid were successfully updated!",
          updatedSelectedItems2: "The selected item in the grid was successfully updated!",
          errorSelectedItems: "The {{quantityItems}} items selected in the grid were sent, but some were NOT successfully processed!",
          errorSelectedItems2: "The selected item in the grid was NOT updated!",
          proposalQuantityIsWrong: "Proposed Quantity field was filled with a value different from the Quantity, please provide a Justification!",
          rememberThisOperation: "Remember that this operation also includes SAP INTEGRATION!",
          selectedItemsNextForecast: "The {{quantityItems}} items selected in the grid were approved and are in the next stage of the 'Workflow'!",
          selectedItemsNextForecast2: "The selected item in the grid was approved and is in the next stage of the 'Workflow'!",
          selectedItemsNextForecastError: "The {{quantityItems}} items selected in the grid were NOT approved and are in the previous stage of the 'Workflow'!",
          selectedItemsNextForecastError2: "The selected item in the grid was NOT approved and is in the previous stage of the 'Workflow'!",
          selectedItemsProcessedWithError: "The {{quantityItems}} items selected in the grid were processed with errors!",
          selectedItemsProcessedWithError2: "The selected item in the grid was NOT processed correctly!",
          selectedItemsDoesNotProcessed: "The {{quantityItems}} items selected in the grid were NOT processed correctly!",
          selectedItemsDoesNotProcessed2: "The selected item in the grid was NOT processed correctly!",
          monthYearRef: "Month Year Ref.",
          processingRequest: "Processing your request will take approximately",
          processingRequest2: "seconds. Please wait!",
          negativeValues: "Negative values are not allowed!",
          undoGeneratedForecasts: "Undo generated forecasts",
          viewRatioData: "View Ratio Data",
          enablesFilteringTheLinesInTheGridBelow: "Enables filtering the lines in the grid below!",
          disableFilteringTheLinesInTheGridBelow: "Disables filtering and returns all lines in the grid below!",
          saveChanges: "Save changes to the selected item in the grid below WITHOUT advancing to the next step!",
          uploadCsv: "Upload csv file and update the list below!",
          downloadCsv: "Download the csv file to be updated and uploaded!",
          continueForecast: "Do you want to continue the Monthly Forecast?",
          reproveData: "Disapprove the data of the selected Item(s) in the list below, and return them to the previous step!",
          sendDataToSap: "Send the data of the selected Item(s) in the list below to SAP, and DO NOT advance or go back a step!",
          importExcel: "Excel Spreadsheet Import!",
          csvWithSuccess: "CSV processed successfully!",
          csvWithError: "Failed to process CSV",
        },
      },
      dailyForecast: {
        titlePage: "Daily Forecast",
        text: {
          exitModal: "Exit Modal",
          whenToMoveProduction: "When to move production?",
          forecastDate: "Forecast Date",
          resetForecastForTheDay: "This will reset the forecast for the day",
          movingQuantity: "moving the quantity of",
          fromSku: "from SKU",
          forTheDay: "for the day",
          movePlan: "Move Plan",
          approvesAllItems: "Approves all items in the list below and moves to the next step!",
          withoutContract: "Without contract!",
          gridItemsUpdatedSuccessfully: "Grid items updated successfully!",
          gridItemsProblems: "Grid items had issues during processing!",
          rememberOperationWithSap: "Remember that this operation also includes SAP INTEGRATION!",
          allItemsWereApproved: "All items were approved and are in the next stage of the 'Workflow'!",
          allItemsWereNotApproved: "All items were NOT approved and are in the previous stage of the 'Workflow'!",
          itemsWereNotProcessed: "Items were not processed correctly!",
          itemUpdatedSuccessfully: "Item updated successfully!",
          errorSavingItem: "Error saving item!",
          exceededMonthlyAmount: "The reported quantity exceeded the monthly amount.",
          monthlyTotalReported: "Total reported for the month:",
          maxAvailable: "Maximum available:",
          referenceMonthYear: "Reference Month/Year:",
          negativeValues: "Negative values are not allowed!",
          enablesFilteringGrid: "Enables filtering the grid lines below by a date range!",
          disableFiltersAndReturn: "Disables filtering and returns all lines in the grid below!",
          viewRatioData: "View Ratio Data",
          saveChangesToSelectedItem: "Save changes to the selected item in the grid below WITHOUT advancing to the next step!",
          uploadCsvFile: "Upload csv file and update the list below!",
          downloadCsvFile: "Download the csv file to be updated and uploaded!",
          doYouWantContinue: "Do you want to continue the Daily Forecast?",
          reproveAllItems: "Disapprove all items in the list below, and return them to the previous step!",
          excelImport: "Excel Spreadsheet Import!",
          csvWithSuccess: "CSV processed successfully!",
          csvWithFail: "Failed to process CSV",
          movePlanWithSuccess: "Plan moved successfully!",
          movePlanWithFail: "Failed to move plan!",
          dailyForecastStep: "Daily Forecast Step",
          sapSupplierCode: "SAP Supplier Code",
          contractConsume: "Contract Consumption",
          defineBasePlan: "Define Base Plan",
          approve: "Approve",
          disapprove: "Disapprove",
          itemsReleasedToLaunchProduction: "Items released to launch production",
          optional: "Optional",
          allStepsCompleted: "All steps have been completed. Including Forecast generation. It is still possible to change contract data, but it will not be possible to recreate the Forecast for already created SKUs and exercises! The final step will be carried out for SKUs included after the last Forecast generation on: Include date here",
        },
      },
      stuffRequest: {
        titlePage: "Raw Material Request",
        text: {
          indicateNeed: "Indicate Need",
          proposeFulfillment: "Propose Fulfillment",
          partnerAcceptance: "Partner Acceptance",
          approveRequestAndGeneratePurchaseOrder: "Approve Request and Generate Purchase Order",
          requestedItems: "Requested Items",
          rawMaterialRequest: "Raw Material Request",
          itemsSavedSuccessfully: "Items saved successfully!",
          errorTryingToSave: "Error trying to save!",
          itemDeletedSuccessfully: "Item deleted successfully!",
          errorTryingToDelete: "Error trying to delete!",
          itemSaveSuccessfully: "Item saved successfully!",
          itemRejectedSuccessfully: "Item rejected successfully!",
          errorTryingFailed: "Error trying to reject!",
          itemsDeletedSuccessfully: "Items deleted successfully.",
          itemApprovedSuccessfully: "Item approved successfully!",
          errorTryingToApprove: "Error trying to approve!",
          proposedDateEarlier: "Proposed Date cannot be earlier than the Request Date!",
          uploadDateEarlier: "Loading Date cannot be earlier than the Request Date!",
          itemAddedSucessfully: "Item added successfully!",
          errorTryingToInclude: "Error trying to include!",
          saveChangesToSelectedData: "Save changes to all selected items in the Grid below, WITHOUT advancing to the next step!",
          enablesFiltering: "Enables filtering the grid lines below by a date range!",
          disableFilters: "Disables filtering and returns all lines in the grid below!",
          addLine: "Add Line",
          uploadCsv: "Upload csv file and update the list below!",
          downloadCsv: "Download the csv file to be updated and uploaded!",
          reproveItemsFromSelectedData: "Disapprove the data of the selected Item(s) in the list below, and return them to the previous step!",
          proceedWithRequest: "Do you want to proceed with the Raw Material Request?",
          deleteSelected: "Delete Selected",
          proceedWithDelete: "Do you want to proceed with deleting the selected materials?",
          excelImport: "Excel Spreadsheet Import!",
          filterGridBy: "Filter Grid By:",
        },
      },
      dailyProductionRelease: {
        titlePage: "Daily Production Release",
        text: {
          approveItemData: "Approve the data of the selected Item(s) in the list below and move to the next step!",
          approvalOfDeviations: "Approval of deviations",
          thePlural: "The ",
          itemsSuccessfullyIntegrated: "selected items in the grid were successfully integrated!",
          itemSuccessfullyIntegrated: "The selected item in the grid was successfully integrated!",
          itemsSuccessfullyUpdated: "selected items in the grid were successfully updated!",
          itemSuccessfullyUpdated: "The selected item in the grid was successfully updated!",
          itemsSuccessfullyFail: "selected items in the grid were not processed properly!",
          itemSuccessfullyFail: "The selected item in the grid was not processed properly!",
          adhesionLessThan: "For adherence less than {{valorAderencia}}%, you must provide the fields: Justify, Compensate within the month, and When?",
          rememberSapIntegration: "Remember that this operation also includes SAP INTEGRATION!",
          itemsApprovedForNextStep: "selected items in the grid were approved and are in the next stage of the 'Workflow'!",
          itemApprovedForNextStep: "The selected item in the grid was approved and is in the next stage of the 'Workflow'!",
          itemsDontApprovedForNextStep: "selected items in the grid were NOT approved and are in the previous stage of the 'Workflow'!",
          itemDontApprovedForNextStep: "The selected item in the grid was NOT approved and is in the previous stage of the 'Workflow'!",
          itemsNotProcessedProperly: "selected items in the grid were not processed properly!",
          itemNotProcessedProperly: "The selected item in the grid was not processed!",
          payWithinMonth: "Compensate within the month?",
          when: "When?",
          for: "For *",
          negativeValuesNotAllowed: "Negative values are not allowed!",
          enablesFilteringByDate: "Enable filtering the lines in the grid below by a date range!",
          disableFilter: "Disable filter and return all lines in the grid below!",
          moveSelectedLine: "Move the selected line(s) to Step 1",
          saveChangesWithoutAdvance: "Save changes to the selected Item in the Grid below WITHOUT advancing to the next step!",
          wishContinue: "Do you want to continue?",
          reproveDataAndBackStep: "Disapprove the data of the selected Item(s) in the list below and return them to the previous step!",
          uploadCsvFile: "Upload a csv file and update the list below!",
          downloadCsvFile: "Download the csv file to be updated and uploaded!",
          excelImport: "Excel Spreadsheet Import!",
          productionRelease: "Production Release",
          gripConfirmation: "Adherence Confirmation and Production Integration with SAP",
        },
      },
      deliveriesFob: {
        pageTitle: "FOB Cargo Tracking",
        text: {
          requiredField: "Required Field!",
          selectPartnerFirst: "You must select the partner before accessing this page.",
          clifor: "Clifor",
          truckPlate: "Truck Plate",
          trailerPlate: "Trailer Plate",
          orderItems: "Order Items",
          showOrderItems: "Order Items",
          enableFiltering: "Enable filtering the lines in the grid below!",
          disableFiltering: "Disable filter and return all lines in the grid below!",
          filterFobCargo: "Filter FOB Cargo",
          itemsOfOrder: "Order Items",
        },
      },
      deliveriesCif: {
        pageTitle: "CIF Cargo Tracking",
        text: {
          requiredField: "Required Field!",
          selectPartnerFirst: "You must select the partner before accessing this page.",
          clifor: "Clifor",
          truckPlate: "Truck Plate",
          trailerPlate: "Trailer Plate",
          orderItems: "Order Items",
          showOrderItems: "Order Items",
          enableFiltering: "Enable filtering the lines in the grid below!",
          disableFiltering: "Disable filter and return all lines in the grid below!",
          filterCifCargo: "Filter CIF Cargo",
          itemsOfOrder: "Order Items",
          loadingHistory: "CIF Loading History",
          dataSaved: "Data was saved successfully.",
          selectedOrderAndItemNotFound: "Selected order and item not found",
          modalTitle: "CIF Loading History",
          modalDescriptionSuccess: "Data was saved successfully.",
          modalDescriptionError: "Error saving changes.",
          tooltipShowLoadingDeliveries: "Show loading history",
          tooltipDeleteLoadingHistory: "Undo delete loading history",
          tooltipAddNewLoad: "Add new load",
          tooltipDownloadFileAndUpdate: "Download the csv file to be updated and uploaded!",
          tooltipUploadFileAndUpdateList: "Upload the csv file and update the list below!",
          tooltipSaveChanges: "Save all the changes made.",
          tooltipExitModal: "Exit the modal",
        },
      },
      deliveriesRawMaterial: {
        pageTitle: "Raw Material Cargo Tracking",
        text: {
          truckPlate: "Truck Plate",
          saveAllChanges: "Save all changes made.",
        },
      },
      stockPartnerBrf: {
        pageTitle: "Stock/BRF Partner",
        text: {
          thisFieldCannotBeEmpty: "This field cannot be empty!",
          thisFieldCanOnlyContainNumbers: "This field can only contain numbers!",
          thisFieldCannotBeLonger: "This field cannot be longer than 5 characters!",
          unableToFindIndustrializationCenter: "Unable to find an Industrialization Center for this partner!",
          csvDownload: "Download the csv file to be updated and uploaded!",
          brfPartner: "BRF Partner",
        },
      },
      stockPartnerNamed: {
        pageTitle: "Stock/Partner",
        text: {
          thisFieldCannotBeEmpty: "This field cannot be empty!",
          thisFieldCanOnlyContainNumbers: "This field can only contain numbers!",
          thisFieldCannotBeLonger: "This field cannot be longer than 5 characters!",
          unableToFindIndustrializationCenter: "Unable to find an Industrialization Center for this partner!",
          selectPartner: "A Partner must be selected!",
          csvDownload: "Download the csv file to be updated and uploaded!",
          partner: "Partner",
        },
      },
      finishiedProduct: {
        pageTitle: "Finished Product",
        text: {
          availableProductsList: "List of Available Products",
          prioritizeDeliveries: "Prioritize Deliveries",
          generatePreOrder: "Generate Pre Order",
          productsAlreadyRequested: "Products Already Requested",
          withoutContract: "Without Contract!",
          finishiedProduct: "Finished Product",
          inconsistencyInReportedBalance: "Inconsistency in the reported balance",
          have: "There is",
          that: "that",
          exceedingBalance: "exceeding the balance",
          wantProceed: "Do you want to proceed without correcting?",
          informOriginCenter: "Origin Center field is required!",
          informDestinyCenter: "Destination Center field is required!",
          informOriginDeposit: "Origin Deposit field is required!",
          informContractSap: "SAP Contract field is required!",
          deliveryDateCannotBeEarlier: "Delivery Date cannot be earlier than the Current Date!",
          deliveryDateCannotBeBefor: "Delivery Date cannot be earlier than the Inclusion Date!",
          quantityMoreThanZero: "Reported quantity must be greater than zero!",
          requiredLoadDate: "A Loading Date is required!",
          originDontInformed: "Loading origin not informed.",
          deliveryDateNeedInformed: "Delivery date must be informed!",
          requiredDestinyCenter: "Destination center must be informed!",
          loadingDateMustBeFilled: "Loading date must be filled",
          thePlural: "The",
          itemsUpdatedSuccessfully: "selected items in the grid were successfully updated!",
          itemUpdatedSuccessfully: "The selected item in the grid was successfully updated!",
          itemsProcessedWithProblems: "selected items in the grid encountered problems during processing!",
          itemProcessedWithProblems: "The selected item in the grid was not processed!",
          totalQuantityReported: "Total quantity reported (in pallets) (",
          isLess: "is less than the minimum palletization quantity",
          isGreater: "is greater than the maximum palletization quantity",
          itemsWithInsufficientBalance: "There are items with insufficient balance to place the order, check the balance column.",
          itemWithInsufficientBalance: "Item with insufficient balance to place an order, check the balance column.",
          insufficientBalance: "Insufficient balance",
          wantProceed2: "Do you want to proceed with the Finished Product request?",
          cancelSelectedOrder: "Cancel selected order(s)",
          moveSelectedOrder: "Move the selected order(s) to Step 2",
          saveChanges: "Save changes to all selected items in the Grid below WITHOUT advancing to the next step!",
          goToNextStep: "Go to the next step",
          itemApproveSuccessfully: "Item approved successfully",
          wantProccedClickYes: "If you want to proceed with the finished product request, fill in the data and click YES.",
        },
      },
      importRequest: {
        pageTitle: "Import Request",
        text: {
          unableToRecoverDate: "Unable to retrieve data! The application presented the following error:",
          requiredSelectedPartner: "A partner must be selected!",
          dataSavedSuccessfully: "Data saved successfully.",
          errorProcessingFile: "Error processing file.",
          ordersUpdatedSuccessfully: "Orders updated successfully!",
          orderUpdatedSuccessfully: "Order updated successfully!",
          errorSavingOrders: "Error saving orders!",
          errorSavingOrder: "Error saving the order!",
          boardingInstructionSequenceNo: "Shipping Instruction Sequence No.",
          boardingSequenceNo: "Shipping Sequence No.",
          purchasingDocument: "Purchase Document - PO",
          item: "Item - PO",
          supplier: "Supplier - PO",
          name: "Name - PO",
          materialPo: "Material - PO",
          acronym: "Acronym - PO",
          description: "Brief Description - PO",
          orderQuantity: "Order Quantity - PO",
          shipmentQuantity: "Shipment Quantity - BEM",
          etd: "ETD",
          eta: "ETA",
          shippingDate: "Shipping Date",
          estatiscalShippingDate: "Statistical Shipping Date",
          commodityReceiptDate: "Commodity Receipt Date",
          registrationDate: "Registration Date - DES",
          month: "Month",
          week: "Week",
          deviationReceiving: "Receiving Deviation",
          justify: "Justification",
          causer: "Cause",
          observation: "Observation",
          orderIntegratedSuccessfully: "Order(s) successfully integrated!",
          errorInIntegration: "Error trying to integrate!",
          justifyRequest: "Justification is required for Receiving Deviation greater than ±7 business days!",
          saveAllLines: "Save all lines.",
          csvDownload: "Download the csv file for batch update.",
          loadCsvFile: "Upload csv file.",
          watchOrderHistory: "View import order history.",
          filter: "Filter",
          sapIntegrate: "SAP Integration",
          config: "Configurations",
          filterImportOrders: "Filter Import Orders",
          order: "Order",
          material: "Material",
          shippingInstruction: "Shipping Instruction",
          sheetImport: "Excel Spreadsheet Import!",
          daysBetweenRequired: "'Days between' parameter must be filled.",
          timeRequired: "'Time' parameter must be filled.",
          saveConfigs: "Save configurations",
          exitConfigs: "Exit configurations",
          waitPlease: "Please wait..",
          differenceLimit: "Day difference limit between ETA and Shipping Date:",
          timeForAutomaticRoutine: "Time for automatic routine execution:",
          exitModal: "Exit modal",
          eventDate: "Event Date",
          orderImportId: "Import Order ID",
          responsible: "Responsible",
          csvDownload2: "Download the csv file to be updated and uploaded!",
          orderHistory: "Import Order History",
        },
      },
      dashboardProductionMonitoring: {
        pageTitle: "Production Monitoring Dashboard",
        text: {
          otif: "OTIF",
          downloadCsv: "Download the csv file to be updated and uploaded!",
          initial: "Initial",
          final: "Final",
          dateTypeDoesNotExist: "Date type does not exist:",
          loadingDataWaitPlease: "Loading data, please wait...",
          percentageOfJustifications: "Percentage of justifications:",
          initialDate: "Start Date",
          finalDate: "End Date",
          portalContract: "Portal Contract",
          partners: "Partners",
          updateDashboardWithFilters: "Update dashboard with selected filters",
          applyFilters: "Apply filters",
          filterDate: "The date filter will always adjust the dates to the start and end of the week.",
          contractFilter: "The contract filter is filled according to the selected partner(s).",
          plannedProducedWeekly: "WEEKLY PLANNED VS PRODUCED",
          plannedProducedDaily: "DAILY PLANNED VS PRODUCED",
          justifications: "JUSTIFICATIONS",
          total: "TOTAL",
          remnant: "REMAINING",
          breaking: "BREAKAGE",
          quantity: "QUANTITY",
          planned: "PLANNED",
          produced: "PRODUCED",
        },
      },
      dashboardContractualComsumption: {
        pageTitle: "Contractual Consumption Dashboard",
        text: {
          contractualComsumption: "Contractual Consumption",
          loadingData: "Loading data, please wait...",
          portalContract: "PORTAL CONTRACT",
          sapContract: "SAP CONTRACT",
          updateDashboardWithSelectedFilters: "Update dashboard with selected filters",
          minimal: "MINIMUM",
          variation: "VARIATION",
          maximum: "MAXIMUM",
          percentageByContractTime: "Percentage by Contract Time",
          volume: "VOLUME",
          consumed: "CONSUMED",
          totalContract: "TOTAL CONTRACT",
          percentageOfQuantityProducedBeforeTheTotalPlan: "Percentage of quantity produced compared to the total planned",
          portalContractNumber: "Portal Contract Number",
          sapContractNumber: "SAP Contract Number",
          downloadCsv: "Download the csv file to be updated and uploaded!",
        },
      },
      dashboardImport: {
        pageTitle: "Import Dashboard",
        text: {
          import: "Import",
          seqNoBoardingInstruction: "Shipping Instruction Seq. No.",
          boardingSequenceNumber: "Shipping Sequence No.",
          csvDownload: "Download the csv file to be updated and uploaded!",
          withoutStatus: "WITHOUT STATUS",
          loadingDataPleaseWait: "Loading data, please wait...",
          startDate: "Start Date",
          finalDate: "End Date",
          partners: "Partners",
          updateDashboardWithSelectedFilters: "Update dashboard with selected filters",
          applyFilters: "Apply Filters",
          deviationsDividedByCause: "DEVIATIONS DIVIDED BY CAUSE",
          deviationsDividedByJustification: "DEVIATIONS DIVIDED BY JUSTIFICATION",
          adherence: "ADHERENCE",
          quantity: "QUANTITY",
          staticDate: "STATIC DATE",
          shippingDate: "SHIPPING DATE",
          requestVersusReceiving: "REQUEST VS RECEIVING",
          period: "PERIOD",
          requested: "REQUESTED",
          received: "RECEIVED",
          amountToReceive: "AMOUNT TO RECEIVE",
        },
      },
      dashboardTracking: {
        pageTitle: "Partner Tracking Dashboard",
        text: {
          dataTypeDoesNotExist: "Data type does not exist:",
          loadingDataPleaseWait: "Loading data, please wait...",
          justifyPercentage: "Percentage of justifications:",
          portalContract: "Portal Contract",
          updateDashboardWithFilteredDara: "Update dashboard with selected filters",
          applyFilters: "Apply filters",
          dateFilter: "The date filter will always adjust the dates to the start and end of the week.",
          contractFilter: "The contract filter is filled according to the selected partner(s).",
          planned: "PLANNED",
          weeklyDelivered: "WEEKLY DELIVERED",
          justification: "JUSTIFICATIONS",
          total: "TOTAL",
          over: "OVER",
          break: "BREAKAGE",
          dailyDelivered: "DAILY DELIVERED",
          quantity: "QUANTITY",
          delivered: "DELIVERED",
          received: "RECEIVED",
          downloadCsvFile: "Download the csv file to be updated and uploaded!",
        },
      },
      login: {
        pageTitle: "Login",
        text: {
          login: "Login",
          email: "Email",
          password: "Password",
          enter: "Enter",
          forgotPassword: "Forgot my password",
          emailRequired: "Email is required",
          passwordRequired: "Password is required",
          invalidEmail: "Invalid email",
          invalidPassword: "Invalid password",
          loginFailed: "Login failed",
          invalidCredentials: "Invalid credentials",
          error: "Error",
          ok: "Ok",
          checkUserPassAndTryAgain: "Check your username and password and try again",
          trygain: "Try again",
        },
      },
    },
    common: {
      id: "ID",
      name: "Name",
      password: "Password",
      nickname: "Nickname",
      email: "Email",
      emails: "Emails",
      group: "Group",
      groups: "Groups",
      address: "Address",
      complement: "Complement",
      neighborhood: "Neighborhood",
      city: "City",
      state: "State/Province/Region",
      stateAbbreviation: "State Abbreviation",
      country: "Country",
      postalCode: "Postal Code",
      phone: "Phone",
      contact: "Contact",
      contactPhone: "Contact Phone",
      website: "Website",
      yes: "Yes",
      no: "No",
      ok: "Ok",
      add: "Add",
      delete: "Delete",
      close: "Close",
      apply: "Apply",
      cancel: "Cancel",
      continue: "Continue",
      warning: "Warning!",
      attention: "ATTENTION!",
      informative: "Informative!",
      error: "Error!",
      field: "Field",
      fields: "Fields",
      value: "Value",
      createdAt: "Created At",
      acronym: "Acronym",
      sku: "Sku",
      skus: "Skus",
      skuId: "Sku ID",
      skuCode: "Sku Code",
      skuDescription: {
        label: "Sku Description",
        placeholder: "Enter the sku description",
      },
      description: "Description",
      language: "Language",
      basicUnit: "Basic Unit",
      materialType: "Material Type",
      materialTypeDescription: "Material Type Description",
      center: "Center",
      centerDescription: "Center - Description",
      distributionCenter: {
        label: "Distribution Center",
        placeholder: "Enter the center",
      },
      local: "Local",
      category: "Category",
      release: "Release",
      order: "Order",
      causer: "Causer",
      back: "Back",
      project: "Project",
      quantity: "Quantity",
      actions: "Actions",
      origin: "Origin",
      origins: "Origins",
      skip: "Skip",
      historic: "Historic",
      viewHistoric: "View Historic",
      plannedQuantity: "Planned Quantity",
      proposedQuantity: "Proposed Quantity",
      producedQuantity: "Produced Quantity",
      orderQuantity: "Order Quantity",
      justify: "Justify",
      generatedDiary: "Generated Diary",
      filter: "Filter",
      filtered: "Filtered",
      seeDetails: "See Details",
      monthYearRef: "Month Year Ref.",
      date: "Date",
      initialDate: "Initial Date",
      finalDate: "Final Date",
      contractNumber: "Contract Number",
      percentageConsumed: "Percentage Consumed",
      day: "Day",
      requestedIn: "Requested In",
      for: "For",
      requestedSku: "Requested SKU",
      requestedSkuId: "Requested SKU ID",
      selectedQuantity: "Selected Quantity",
      requestJustify: "Request Justification",
      loadDate: "Load Date",
      proposalDate: "Proposal Date",
      proposalSku: "Proposed SKU",
      proposalSkuId: "Proposed SKU ID",
      proposalQuantity: "Proposed Quantity",
      proposalJustify: "Proposed Justification",
      warehouse: "Warehouse",
      contract: "Contract",
      contractSap: "SAP Contract",
      observationRule: "Observation Rule",
      exclusion: "Exclusion",
      finish: "Finish",
      next: "Next",
      prev: "Previous",
      csvWithSuccess: "CSV Processed Successfully!",
      csvWithError: "Failed to process the CSV",
      grip: "Adherence",
      shipmentDate: "Shipment Date",
      deliveryDate: "Delivery Date",
      shipping: "Shipping",
      orderNumber: "Order Number",
      itemNumber: "Item Number",
      item: "Item",
      items: "Items",
      balance: "Balance",
      amountReceived: "Amount Received",
      quantityLoaded: "Quantity Loaded",
      expectedDeliveryDate: "Expected Delivery Date",
      sapDeliveryDate: "SAP Delivery Date",
      lastLoadDate: "Last Load Date",
      destination: "Destination",
      loadHistory: "Load History",
      showLoadHistory: "Show Load History",
      originCenter: "Origin Center",
      boardingDate: "Boarding Date",
      invoice: "Invoice",
      observations: "Observations",
      report: "Report",
      attachReport: "Attach Report",
      downloadReport: "Download Report",
      deleteReport: "Delete Report",
      measurementUnit: "Measurement Unit",
      save: "Save",
      material: "Material",
      materialDescription: "Material - Description",
      sapQuantity: "SAP Quantity",
      partnerQuantity: "Partner Quantity",
      distinction: "Difference",
      options: "Options",
      edit: "Edit",
      skuIdDelivery: "SKU ID - Delivery",
      palletizing: "Palletizing",
      loadingDate: "Loading Date",
      loading: "Loading",
      originDeposit: "Origin Deposit",
      destinationCenter: "Destination Center",
      destinationDeposit: "Destination Deposit",
      itIs: "It is",
      are: "Are",
      noResults: "No results",
      step: "Step",
      searchDistributionCenter: "Search Distribution Center",
      statusBooking: "Booking Status",
      canceled: "CANCELED",
      reset: "Reset",
      partner: "Partner",
      partners: "Partners",
      week: "Week",
      status: "Status",
      deviation: "Deviation",
      recover: "Recover",
      compensationDate: "Compensation Date",
      compensationWeek: "Compensation Week",
      accomplishedQuantity: "Accomplished Quantity",
      quantityDeviation: "Quantity Deviation",
      compensation: "Compensation",
      compensationQuantity: "Compensation Quantity",
      weekCompensation: "Compensation Week",
      contractTotalQuantiy: "Total Contract Quantity",
      percentageProduced: "Percentage Produced",
      percentageOfContractTime: "Percentage of Contract Time",
      endDate: "End Date",
      minimalVariation: "Minimal Variation",
      maximumVariation: "Maximum Variation",
      requested: "Requested",
      received: "Received",
      water: "WATER",
      harbor: "HARBOR",
      awaitingBilling: "AWAITING BILLING",
      bookingStatus: "Booking Status",
      purchasingDocument: "Purchasing Document",
      shipmentQuantity: "Shipment Quantity",
      staticShippingDate: "Static Shipping Date",
      stockEntryForecast: "Stock Entry Forecast",
      entryIntoStock: "Entry Into Stock",
      deliveredQuantity: "Delivered Quantity",
      justification: "Justification",
      otif: "OTIF",
      fileUpload: {
        resultProcessingFile: "File Processing Result: ",
        fileSize: "File Size in bytes: ",
        lastModifiedDate: "Last Modified Date: ",
        submit: "Submit",
        selectFileForDetails: "Select a .csv file to view details...",
        uploadFile: "Upload File",
        selectFileFirst: "Select a file first",
      },
      stepLogsHistoryDetalhe: {
        modal: {
          title: "Item ID {{id}} history changes of {{name}}",
        },
      },
      dashboardFilters: {
        form: {
          label: "What type of data would you like to load?",
          buttonGeneralData: "General Data",
          buttonSpecieficPartner: "Specific Partner",
          errorDate: "Start and end dates must be selected!",
          maxDateError: "The selected period cannot exceed 90 days!",
          lastQuarter: "Last quarter",
          specificPeriod: "Specific period",
          startDate: "Start Date",
          endDate: "End Date",
          loadData: "Fetch data and load dashboard",
        },
      },
      autoComplete: {
        centro: {
          label: "Search distribution center",
        },
        centroVirtual: {
          label: "Search virtual center",
        },
        contrato: {
          label: "Search contract",
        },
        email: {
          label: "Search email",
        },
        justificativa: {
          label: "Search justification",
        },
        listaTecnica: {
          label: "Search SKU",
        },
        parceiro: {
          label: "Search partner",
        },
        projeto: {
          label: "Search project",
        },
        propriedade: {
          label: "Search parameter",
        },
      },
    },
    global: {
      button: {
        new: "New",
        edit: "Edit",
        delete: "Delete",
        save: "Save",
        cancel: "Cancel",
        back: "Back",
        search: "Search",
        filter: "Filter",
        clear: "Clear",
        close: "Close",
        add: "Add",
        remove: "Remove",
        yes: "Yes",
        no: "No",
        ok: "Ok",
        apply: "Apply",
        reset: "Reset",
        download: "Download",
        upload: "Upload",
        approve: "Approve",
        disapprove: "Disapprove",
        proceed: "Proceed",
        continue: "Continue",
        send: "Send",
        generate: "Generate",
        view: "View",
        confirm: "Confirm",
        exit: "Exit",
        step: "Step",
        skip: "Skip"
      },
      table: {
        dateAndHour: "Date and Hour",
        user: "User",
        description: "Description",
        contractNumber: "Contract Number",
        freight: "Freight",
        startVigency: "Start of Validity",
        endVigency: "End of Validity",
        itemQuantity: "Item Quantity",
        consumption: "Consumption",
        seeDetails: "See Details",
        group: "Group",
        parameter: "Parameter",
        value: "Value",
        order: "Order",
        item: "Item",
        skuDescription: "SKU Description",
        loadedQuantity: "Loaded Quantity",
        loadingDate: "Loading Date",
        deliveryDate: "Delivery Date",
        truckPlate: "Truck Plate",
        truckHorsePlate: "Trailer Plate",
        breakQuantity: "Break Quantity",
        breakJustification: "Break Justification",
        sapCode: "SAP Code",
        day: "Day",
        partner: "Partner",
        contract: "Contract",
        skuId: "SKU ID",
        productionMade: "Production Made",
        productionReceived: "Production Received",
        justification: "Justification",
        averagePrice: "Average Price",
        activity: "Activity",
        subActivity: "Sub Activity",
        family: "Family",
        subGroup: "Sub Group",
        center: "Center",
        protein: "Protein",
        week: "Week",
        sapContract: "SAP Contract",
        origin: "Origin",
        name: "Name",
        reference: "Reference",
        status: "Status",
        step: "Step",
        partnerAggregated: "Aggregated Partner",
      },
      tooltip: {
        downloadFileAndUpdate: "Download the csv file to be updated and uploaded!",
        deleteOrigin: "Delete origin",
        changesHistory: "Change history",
        addNewOrigin: "Add new origin",
        closeModal: "Close modal",
        newParameter: "New parameter",
        updateParameter: "Parameter updated",
      },
      message: {
        rowUpdatedSuccessfully: "Record updated successfully!",
        rowUpdatedFillingTheFields: "Record added, please fill in the data in the grid.",
        rowDeletedSuccessfully: "Record deleted successfully!",
        warning: "Warning!",
        selectPartner: "To use this feature, you need to select a partner!",
        selectPartnerFirst: "You need to select a partner before accessing this feature.",
        selectPartnerToContinue: "To access this feature, you need to select a partner first.",
        selectPartnerBelow: "Select a partner below to continue:",
        partnerSelectionRequired: "Partner selection required",
        partnerSelectionHint: "Tip: You can change partners at any time by clicking the icon next to the partner name in the header.",
        parameterDeleted: "Parameter deleted successfully!",
        partnerAdded: "Aggregated partner added successfully!",
        partnerUpdated: "Aggregated partner updated successfully!",
        propertyAddWithSuccess: "Property added successfully!",
        propertyUpdatedWithSuccess: "Property updated successfully!",
      },
      dialog: {
        deletePartnerAggregated: "Do you really want to delete the aggregated partner?",
        deletePartnerAggregatedSubTitle: "You requested the deletion of the Aggregated Partner.",
        providerCode: "Provider Code: ",
        confirmOperation: "Confirm the operation?",
      }
    },
  },
};
